class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".card-wrapper").forEach(card => {
    const select = card.querySelector('#gift-variant-select');
    const priceEl = card.querySelector(".base-price");
    const compareEl = card.querySelector(".sel-price");
    const variantInput = card.querySelector('input[name="id"]');
    const addToCartBtn = card.querySelector('button[type="submit"].quick-add__submit');

    if (!select) return;

    function updateVariant() {
      const option = select.options[select.selectedIndex];

      if (priceEl) priceEl.textContent = option.dataset.price;

      if (compareEl && option.dataset.sel && option.dataset.sel !== "" && option.dataset.sel !== "$0.00") {
        compareEl.textContent = option.dataset.sel;
      }

      if (variantInput) variantInput.value = option.value;

      const available = option.dataset.available === "true";
      console.log(available);
      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        addToCartBtn.classList.toggle("disabled", !available);
      }
    }
    
    updateVariant();
    select.addEventListener("change", updateVariant);
  });
});


document.addEventListener('cart:updated', updateFreeShippingBar);
document.addEventListener('DOMContentLoaded', updateFreeShippingBar);

function updateFreeShippingBar() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const bar = document.querySelector('.free-shipping-bar');
      if (!bar) return;

      const threshold = parseFloat(bar.dataset.threshold);
      const total = cart.total_price / 100;
      const remaining = Math.max(threshold - total, 0);
      const progress = Math.min((total / threshold) * 100, 100);

      bar.querySelector('.progress-bar__fill').style.width = progress + '%';

      const text = bar.querySelector('.free-shipping-text');
      if (remaining > 0) {
        text.innerHTML = `You’re only <strong>$${remaining.toFixed(2)}</strong> away from Free Shipping!`;
      } else {
        text.innerHTML = `🎉 You’ve unlocked Free Shipping!`;
      }
    });
}